const s = {
  name: "PlusIcon",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,0h8v16h16v8H24v16h-8V24H0v-8h16V0z M18,2v16H2v4h16v16h4V22h16v-4H22V2H18z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PlusIcon
};
